/**
 * pipelineAnomalyDiff.js — Phase G · pure rising/falling edge detector
 *
 * Helper extracted from `useAnomalyToasts` so it can be unit-tested in
 * isolation. Given the previous + current set of anomaly reason codes,
 * returns the set of edges that crossed (rising = newly anomalous,
 * falling = newly recovered).
 */
export function diffAnomalyEdges(prevCodes, currentCodes) {
  const prev = prevCodes instanceof Set ? prevCodes : new Set(prevCodes || []);
  const curr = currentCodes instanceof Set ? currentCodes : new Set(currentCodes || []);
  const rising = [];
  const falling = [];
  for (const code of curr) {
    if (!prev.has(code)) rising.push(code);
  }
  for (const code of prev) {
    if (!curr.has(code)) falling.push(code);
  }
  return { rising, falling };
}
